<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { trackDiagram } from '@/lib/tracks'

/**
 * The black drawing of a track, on the light surface it needs: the outline is black on a transparent
 * background, so it only reads on paper. The `available` event tells the page whether there is one.
 */
const props = defineProps({
  /** Track id, as config/tracks.php names it and the API returns it. */
  trackId: { type: String, default: null },
  /** Tallest the drawing may get, in pixels. */
  maxHeight: { type: Number, default: 220 },
})

const emit = defineEmits(['available'])

const { t } = useI18n()

const imageUrl = ref(null)

watch(() => props.trackId, (trackId) => {
  imageUrl.value = null
  emit('available', false)

  if (!trackId) return

  trackDiagram(trackId).then((url) => {
    if (props.trackId !== trackId) return
    imageUrl.value = url
    emit('available', Boolean(url))
  })
}, { immediate: true })
</script>

<template>
  <div v-if="imageUrl" class="track-diagram">
    <img
      :src="imageUrl"
      :alt="t('trackInfo.diagramAlt')"
      :style="{ maxHeight: `${maxHeight}px` }"
    >
  </div>
</template>

<style scoped>
.track-diagram {
  display: flex;
  justify-content: center;
  padding: 12px;
  border-radius: 8px;
  background: #dddddd;
}

.track-diagram img {
  display: block;
  width: 100%;
  object-fit: contain;
}
</style>
